module.exports = __webpack_public_path__ + "media/images/85/healthy-ea4d97e12d5169750e0ff447f9a9046e.jpg";